<template>
  <div class="container">
    <div
      id="page1-div"
      class="container interline border page-container"
    >
      <div class="col-12 p-4">
        <div class="col-12 text-center pt-4 pb-3">
          <u class="ft12Black">
            CARTA RESPONSIVA<br />
            (PROVEEDOR ADQUIRENTE)
          </u>
        </div>
        <div class="col-12 text-justify pt-4">
          <span class="ft10">
            En la Ciudad de CD,
            <span v-bind:class="{ marca: data.showMarca }">
              {{ data.municipio_cliente }}</span
            >,<span v-bind:class="{ marca: data.showMarca }" class="ft10Black">
              {{ data.estado_cliente }}</span
            >, el
            <span v-bind:class="{ marca: data.showMarca }">
              {{ data.fecha_contrato }}
              </span>
            <br /><br />
            reunidos por una parte, como Proveedor, el(la) señor(a)
            <span v-bind:class="{ marca: data.showMarca }">
              {{ data.nombre_cliente }}</span
            >, con domicilio en la CALLE
            <span v-bind:class="{ marca: data.showMarca }">
              {{ data.calle_cliente }},
              </span> No.
            <span v-bind:class="{ marca: data.showMarca }">
              {{ data.numero_calle_cliente }}
            </span>
            COLONIA
            <span v-bind:class="{ marca: data.showMarca }">
              {{ data.colonia_cliente }}</span
            >, CODIGO POSTAL
            <span v-bind:class="{ marca: data.showMarca }">
              {{ data.codigo_postal_cliente }}</span
            >, DE LA POBLACION DE
            <span v-bind:class="{ marca: data.showMarca }">
              {{ data.municipio_cliente }}</span
            >,
            <span v-bind:class="{ marca: data.showMarca }" class="ft10Black">
              {{ data.estado_cliente }},
            </span>
             y por la otra, como Adquirente, GPI AUTO COMERCIAL SAPI DE C.V.
            con domicilio en la calle de Av. De Rosas 2991, col Chapalita C.P.
            44510, Guadalajara, Jalisco; celebramos una carta responsiva al
            tenor de las siguientes:
            <div class="col-12 text-center">
              <br />
              <span class="ft11Black">Cláusulas</span>
              <br />
              <br />
            </div>
            <span class="ft10Black">Primera.</span> El Proveedor transmite al
            Adquirente, el automóvil marca
            <span v-bind:class="{ marca: data.showMarca }" class="ft10Black">
              {{ data.marca_vehiculo }},
            </span>
             modelo
            <span v-bind:class="{ marca: data.showMarca }" class="ft10Black">
              {{ data.modelo_vehiculo }},
            </span>
             año
            <span v-bind:class="{ marca: data.showMarca }" class="ft10Black">
              {{ data.año_vehiculo }},
            </span>
             número de motor
            <span v-bind:class="{ marca: data.showMarca }" class="ft10Black">
              {{ data.numero_motor_vehiculo }},
            </span>
             número de serie
            <span v-bind:class="{ marca: data.showMarca }" class="ft10Black">
              {{ data.numero_serie_vehiculo }}</span
            >.
            <br />
            <br />
            <span class="ft10Black">Segunda. </span>El importe de la operación es
            por la cantidad de
            <span v-bind:class="{ marca: data.showMarca }" class="ft10Black">
              ${{ data.monto_a_finaciar }}</span
            >
             <br />
            estando el Proveedor de acuerdo con la misma, por lo que otorga a
            favor del Adquirente el finiquito más amplio que en derecho proceda,
            por lo que no se reserva acción o derecho alguno en contra del
            Adquirente.
            <br />
            <br />
            <span class="ft10Black">Tercera.</span>
            El Adquirente después de haber revisado por cuenta propia el
            automóvil detallado en la cláusula primera anterior, respecto de su
            estado físico, mecánico, funcional y de uso, lo recibe del
            Proveedor, en las condiciones en que actualmente se encuentra. En
            tal virtud, el Adquirente acusa la recepción del bien de referencia,
            a su entera satisfacción, por conducto de la presente carta
            responsiva.
            <br />
            <br />
            Asimismo, el Proveedor en este acto entrega al Adquirente los
            siguientes documentos en original que son relativos a dicho
            automóvil:
            <br />
            <br />
            a) Factura número
            <span v-bind:class="{ marca: data.showMarca }">
              {{ data.numero_factura }}
            </span>
            DEL
            <span v-bind:class="{ marca: data.showMarca }">
              {{ data.fecha_factura }}
            </span>, expedida por
            <span v-bind:class="{ marca: data.showMarca }">
              {{ data.emisor_factura}}.
            </span>
            <br />
            <br />
            b) Pagos del impuesto sobre tenencia de vehículos de los años
            2019.2020.2021.2022.2023.
            <br />
            <br />
            Póliza de seguro expedida por
            <span v-bind:class="{ marca: data.showMarca }" class="ft10Black">
              {{ data.seguro_nombre }}</span
            >
            con fecha de vencimiento. <br />
            <br />
            d) Otros (detallar): .
            <br />
            <br />
            En tal virtud, el Adquirente acusa la recepción de dichos
            documentos, a su entera satisfacción, por conducto de la presente
            carta responsiva.
            <br />
            <br />
            <span class="ft10Black">Cuarta.</span> El Proveedor acepta toda
            responsabilidad civil, penal o de transito en que se haya
            involucrado, con anterioridad a este acto, el citado bien.
            Consecuentemente, a partir de la hora y fecha de celebración de la
            presente carta responsiva, el Adquirente asume cualquier
            responsabilidad y/u obligación que se derive respecto de y/o sea
            inherente a dicho bien.
            <br />
            El Adquirente gestionará y dará el o los avisos de cambio de
            propietario del citado vehículo que deban presentarse a las
            autoridades competentes.
            <br />
            <br />
            <span class="ft10Black">Quinta.</span> Las partes manifiestan su
            absoluta conformidad con las cláusulas que anteceden, en
            consecuencia, firman al calce de la presente carta responsiva, para
            constancia.
          </span>
        </div>
        <div class="col-12 row pt-4 pb-5">
          <div class="col-5 offset-1 text-center">
            <span class="ft11">
              El Proveedor
            </span>
          </div>
          <div class="col-1 text-center"></div>
          <div class="col-5 text-center">
            <span class="ft11">
              El Adquiriente
            </span>
          </div>
        </div>
        <div class="col-12 row pt-4">
          <div class="col-5 offset-1 border-top border-dark text-center">
            <span class="ft11">
              <span v-bind:class="{ marca: data.showMarca }" class="ft10Black">
                {{ data.nombre_cliente }}
              </span>
            </span>
          </div>
          <div class="col-1 text-center">
            <span class="ft11">
            </span>
          </div>
          <div class="col-5 border-top border-dark text-center">
            <span class="ft11">
              GPI AUTO COMERCIAL SAPI DE C.V.<br />
              Cargo: Representante Legal
            </span>
          </div>
        </div>
        <div>
          <br /><br /><br /><br /><br />
        </div>
        <div v-if="data.tipoAval" class="col-12 row ">
          <div class="col-3 text-center"></div>
          <div class="col-6 border-bottom border-dark text-center">
            <span class="ft11">
              <span v-bind:class="{ 'marca-aval': data.showMarca }">
                {{ data.nombre_aval }}
              </span>
            </span>
          </div>
          <div class="col-3 text-center"></div>
        </div>

        <div v-if="data.tipoAval" class="col-12 row ">
          <div class="col-3 text-center"></div>
          <div class="col-6 text-center pt-3">
            <span class="ft11">
              NOMBRE Y FIRMA DEL AVAL Y OBLIGADO SOLIDARIO
            </span>
          </div>
          <div class="col-3 text-center"></div>
        </div>
        <div v-if="data.tipoObligado" class="col-12 row  ">
          <div class="col-3 text-center"></div>
          <div class="col-6 border-bottom border-dark text-center">
            <span class="ft11">
              <span v-bind:class="{ 'marca-obligado': data.showMarca }">
                {{ data.nombre_obligado }}
              </span>
            </span>
          </div>
          <div class="col-3 text-center"></div>
        </div>
        <div v-if="data.tipoObligado" class="col-12 row">
          <div class="col-3 text-center"></div>
          <div class="col-6 text-center ">
            <span class="ft11">
              NOMBRE Y FIRMA DEL AVAL Y OBLIGADO SOLIDARIO
            </span>
          </div>
          <div class="col-3 text-center"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "IntruccionPAgoTErceros",
  data() {
    return {};
  },
  validations() {
    return {};
  },
  props: {
    data: {
      type: Object
    }
  },
  methods: {},
  created() {
    window.scrollTo(0, 0);
  }
};
</script>
<style type="text/scss">
@import "../style.scss";
</style>



// WEBPACK FOOTER //
// src/views/Contratos/cartas/CartaResponsiva.vue